import { LOCATION_CHANGE } from '../actions';

export const createRouterMiddleware = (history) => {
  return () => (next) => (action) => {
    if (action.type === LOCATION_CHANGE) {
      return next(action);
    }

    const {
      payload: { method, args },
    } = action;

    history[method](...args);
    return undefined;
  };
};
